/**
 * @param {import('@/types/api').Appointment} appointment
 */
export function canTriggerStylistReady(appointment) {
  return (
    appointment.status === 'checked_in' &&
    Boolean(appointment.customer?.phone?.trim())
  )
}

/**
 * @param {string | null | undefined} stylistReadyAt
 */
export function stylistReadyLabel(stylistReadyAt) {
  if (!stylistReadyAt) {
    return null
  }

  const date = new Date(stylistReadyAt)
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
}
